
















































































import _ from 'lodash';
import { Component, Vue } from 'vue-property-decorator';

import { Setting as terms } from '@/const/terms/mainTerms';
import { ComponentTerms as compTerms } from '@/const/terms/componentTerms';
import { SetInventory as feedbackTerms } from '@/const/terms/feedback/inventory';

import { INVENTORY_TYPE, AD_FORMAT, SSP_FORMAT_TYPE, AD_FORMAT_RAW_TYPE, AD_FORMAT_KEY, IINVENTORY, IINVENTORY_RESPONSE, IAPP_INVENTORY, IAPP_RESPONSE, IINVENTORY_RESPONSE_IN_APP } from '@/const/types';
import { INVENTORY_TYPE_MAP, AD_FORMAT_MAP, AD_FORMAT_SELECT, SSP_FORMAT_WRAP, ISSPFormatSelectMap, IFormatMapBySSPAdFormat, IFormatMapByAdFormat, SSP_FORMAT_MAP } from '@/const/options';
import { DefaultOption, TableOptionType } from '@/const/options/DefaultTableOption';
import {
    AppsType,
    AppResponse,
} from './types';

import { Table as ElTable } from 'element-ui';
import { TableColumn } from 'element-ui/types/table-column.d';
import { AxiosError, AxiosResponse } from 'axios';

import Select from '@/components/ElementComponent/Select/index.vue';

@Component<Inventory>({
    name: 'Inventory',
    components: {
        Select,
    },
    beforeRouteLeave (to: any, from: any, next: any) {
        if (to.name === 'login' || this.isModified === false) {
            next();
        } else {
            this.$confirm(feedbackTerms.warnIsModified,'Warning', {
                confirmButtonText: '네',
                cancelButtonText: '아니오',
                type: 'warning'
            }).then((confirm: any) => {
                next();
            })
            .catch(() => {})
        }
    },
})
export default class Inventory extends Vue {
    private terms = terms;
    private compTerms = compTerms;
    private SSP_FORMAT_WRAP = SSP_FORMAT_WRAP;
    private AD_FORMAT_SELECT = AD_FORMAT_SELECT;

    private loading: boolean = false;
    private tableOptions: TableOptionType = DefaultOption;
    private appData: AppsType = [];
    private currentApp: IAPP_INVENTORY | null = null;
    private editModel: IINVENTORY[] = [];

    private isModified: boolean = false;
    private isEditMode: boolean = false;
    private formatAdFormat(row: any, format: AD_FORMAT): string {
        const type = row.type as INVENTORY_TYPE;

        if (AD_FORMAT_MAP[type]) {
            const sspFormats = AD_FORMAT_MAP[type] as IFormatMapBySSPAdFormat;
            const sspFormat = row.sspFormat as SSP_FORMAT_TYPE;
            if (sspFormats[sspFormat]) {
                const formats = sspFormats[sspFormat] as IFormatMapByAdFormat;
                if (formats[format]) {
                    return (
                        `${INVENTORY_TYPE_MAP[type]} : ${formats[format]}\n`
                    ) as string;
                }
            }
        }
        
        return '['+ compTerms.general.invalidFormat +']';
    }
    private formatBaseType(row: any, column: TableColumn): string {
        const base = SSP_FORMAT_MAP[row[column.property]];
        if (base) {
            return base as string;
        }
        return '[알 수 없는 비율] ' + (base ? base : '');
    }
    private formatType(row: any, column: TableColumn): string {
        return INVENTORY_TYPE_MAP[row[column.property]];
    }
    get selectedApp(): IINVENTORY[] {
        if (this.isEditMode) {
            if (this.editModel) {
                return this.editModel as IINVENTORY[];
            }
        } else {
            if (this.currentApp) {
                return this.currentApp.inventory as IINVENTORY[];
            }
        }
        return [] as IINVENTORY[];
    }
    private confirmCancelWhenModified(callback: () => any) {
        this.$confirm(feedbackTerms.warnIsModified, 'Warning', {
            confirmButtonText: '네',
            cancelButtonText: '아니오',
            type: 'warning'
        }).then((res: any)=>{
            callback();
            this.isModified = false;
        }).catch(() => {});
    }
    private isModifiedOn() {this.isModified = true;}
    private handleCancel() {
        if (this.isModified) {
            this.confirmCancelWhenModified(() => {
                this.isEditMode = false;
                this.editModel = [];
            });
        } else {
            this.isEditMode = false;
            this.editModel = [];
        }
    }
    private handleSave() {
        if (this.currentApp && this.isModified) {
            this.loading = true;
            this.submit().then((res: any) => res.data)
                .then((data: {result: boolean}) => {
                    if( data && data.result) {
                        const nowApp = this.currentApp as IAPP_INVENTORY;
                        Vue.set(nowApp, 'inventory', this.editModel);
                        this.isEditMode = false;
                        this.isModified = false;
                        this.editModel = [];
                        this.$notify.success(feedbackTerms.save.success);
                        return;
                    }
                    throw new Error(feedbackTerms.save.error.fail);
                })
                .catch((err: AxiosError) => {
                    if (err.response && (err.response as AxiosResponse).status !== 200 ) {
                        this.$notify.error(feedbackTerms.save.error.fail);
                    } else {
                        this.$notify.error(err.message);
                    }
                    throw err;
                })
                .finally(()=>{
                    this.loading = false;
                })
        }
    }
    private handleAdd(row: any) {
        if (row) {
            const nowInventory = row as IINVENTORY;
            const invMap = AD_FORMAT_MAP[row.type] as IFormatMapBySSPAdFormat;
            if (invMap) {
                const formatMap = invMap[row.sspFormat] as IFormatMapByAdFormat;
                if (formatMap) {
                    const v = Number.parseInt(Object.keys(formatMap)[0]);
                    nowInventory.format.push(v);
                    const table = this.$refs.table as ElTable;
                    table.doLayout();
                    this.isModifiedOn();
                    return;
                }
            }
        }
        this.$notify.info(feedbackTerms.noFormat);
    }
    private handleEdit() {
        if (this.currentApp) {
            const nowApp = this.currentApp as IAPP_INVENTORY;
            this.isEditMode = true;
            this.editModel = _.cloneDeep(nowApp.inventory);
        }
    }
    private handleRemove(row: any, format: AD_FORMAT, index: number) {
        if (row) {
            const nowInventory = row as IINVENTORY;
            nowInventory.format.splice(index, 1);
            this.isModifiedOn();
        }
    }
    private handleAppSelect(val: IAPP_INVENTORY) {
        if (this.isModified) {
            this.confirmCancelWhenModified(() => {
                this.isEditMode = false;
                this.editModel = [];
                this.currentApp = val;
            });
        } else {
            this.isEditMode = false;
            this.editModel = [];
            this.currentApp = val;
        }
    }

    private getAppsdataHandler() {
        this.loading = true;
        this.getAppsData().then((res: any) => res.data)
            .then((data: AppResponse)=>{
                this.appData = data.map((item: IAPP_RESPONSE) => {
                    const inventory = (item.inventory.map((inv: IINVENTORY_RESPONSE_IN_APP) => {
                        const format = inv.format_raw.map((v: AD_FORMAT_RAW_TYPE)=>{
                            const key = AD_FORMAT_KEY(inv.type, v.width, v.height);
                            return AD_FORMAT[key];
                        });
                        return {
                            app_key: item.key,
                            id: inv.id,
                            name: inv.name,
                            type: inv.type,
                            sspFormat: inv.sspFormat,
                            format: format,
                        } as IINVENTORY;
                    }) as IINVENTORY[])
                        .sort((a: IINVENTORY, b: IINVENTORY) => a.name < b.name ? -1 : 1);
                    
                    return {
                        key: item.key,
                        name: item.name,
                        platform: item.platform,
                        packageName: item.packageName,
                        inventory: inventory
                    }
                })
                    .sort((a: IAPP_INVENTORY, b: IAPP_INVENTORY) => a.name < b.name ? -1 : 1);
            })
            .catch((err: AxiosError) => {
                if (err.response && (err.response as AxiosResponse).status !== 200) {
                    this.$notify.error(feedbackTerms.getResponse.error.fail);
                } else {
                    this.$notify.error(err.message);
                }
                throw err;
            })
            .finally(()=>{
                this.loading = false;
            })
    }

    private submit() {
        const nowApp = _.cloneDeep(this.currentApp as IAPP_INVENTORY);
        nowApp.inventory = this.editModel;
        const inventory = nowApp.inventory.map((item: IINVENTORY) => {
            return {
                id: item.id,
                name: item.name,
                type: item.type,
                formats: item.format,
            }
        })
        return this.$http.adserverAPI.post('UpdateSSPPlacementFormatMatch', {
            app_key: nowApp.key,
            inventories: inventory
        })
    }
    // private submit() {
    //     const nowApp = _.cloneDeep(this.currentApp as IAPP_INVENTORY);
    //     nowApp.inventory = this.editModel;
    //     return Promise.resolve(JSON.parse(JSON.stringify(true)));
    // }
    private getAppsData(){
        return this.$http.adserverAPI.post('GetSSPAppList', { all_campaign_type: false });
    } 

    private created() {
        this.$nextTick( ()=>{
            this.getAppsdataHandler();
        })
    }
}
